module.exports = __webpack_public_path__ + "static/media/p4s.2818ea08.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/p4s.png
// module id = 273
// module chunks = 0